import { utility_controller } from '../utility/utility_controller'

var prevnext_news_controller = {
	i: function () {
		i()
	},
}

var i = function () {
	setStateMap()
	stateMap.newsMeta = JSON.parse(layData.newsMeta)

	window.laytheme.on('newpageshown', function () {
		setStateMap()
		updateNewsPrevNextLinksAddedWithTinyMCE()
	})
}

export default prevnext_news_controller

var stateMap = {
	id: null,
	catid: null,
	type: null,
	newsMeta: [],
}

var setStateMap = function () {
	stateMap.catid = utility_controller.parseIdsString(jQuery('body').attr('data-catid'))
	stateMap.id = jQuery('body').attr('data-id')
	stateMap.type = jQuery('body').attr('data-type')
}

var getNewsIndex = function (nextprev) {
	// newsMeta is not indexed by category ids when prevnext goes through all projects
	var ix, i
	var currentId = stateMap.id
	var length = stateMap.newsMeta.length

	for (i = 0; i < length; i++) {
		if (currentId == stateMap.newsMeta[i]['id']) {
			ix = i
			break
		}
	}

	if (nextprev == 'next') {
		ix++
		if (ix == length) {
			ix = 0
		}
	} else if (nextprev == 'prev') {
		ix--
		if (ix < 0) {
			ix = length - 1
		}
	}
	return ix
}

var getNewsLinkObj = function (nextprev) {
	var ix = getNewsIndex(nextprev)
	if (jQuery.isNumeric(ix)) {
		return {
			title: stateMap.newsMeta[ix]['title'],
			url: stateMap.newsMeta[ix]['url'],
			id: stateMap.newsMeta[ix]['id'],
			catid: stateMap.newsMeta[ix]['catid'],
			thumb: stateMap.newsMeta[ix]['thumb'],
			thumbar: stateMap.newsMeta[ix]['thumbar'],
		}
	}
}

var updateNewsPrevNextLinksAddedWithTinyMCE = function ($parent) {
	if ($parent == undefined) {
		$parent = jQuery('body')
	}
	// using body "data-type" attr here instead of checking history state, because document ready can be called before history has initialized on slower connections
	if (jQuery('body').attr('data-type') == 'lay_news') {
		$parent.find('a[href="#laynextproject"], a.laynextproject').each(function () {
			var obj = getNewsLinkObj('next')
			if (typeof obj != 'undefined') {
				jQuery(this).attr({
					'data-type': 'news',
					href: obj.url,
					'data-catid': utility_controller.stringifyCatIds(obj.catid),
					'data-id': obj.id,
					'data-title': obj.title,
				})
				var text = jQuery(this).attr('data-original-text') == undefined ? jQuery(this).text() : jQuery(this).attr('data-original-text')
				if (text.includes('$nextprojecttitle$')) {
					if (jQuery(this).attr('data-original-text') == undefined) {
						jQuery(this).attr('data-original-text', text)
					}
					var newText = text.replace('$nextprojecttitle$', obj.title)
					jQuery(this).text(newText)
				}
			}
		})

		$parent.find('a[href="#layprevproject"], a.layprevproject').each(function () {
			var obj = getNewsLinkObj('prev')
			if (typeof obj != 'undefined') {
				jQuery(this).attr({
					'data-type': 'news',
					href: obj.url,
					'data-catid': utility_controller.stringifyCatIds(obj.catid),
					'data-id': obj.id,
					'data-title': obj.title,
				})
				var text = jQuery(this).attr('data-original-text') == undefined ? jQuery(this).text() : jQuery(this).attr('data-original-text')
				if (text.includes('$previousprojecttitle$')) {
					if (jQuery(this).attr('data-original-text') == undefined) {
						jQuery(this).attr('data-original-text', text)
					}
					var newText = text.replace('$previousprojecttitle$', obj.title)
					jQuery(this).text(newText)
				}
			}
		})
	}
}
// for marquee lazyloadable js
window.updateNewsPrevNextLinksAddedWithTinyMCE = updateNewsPrevNextLinksAddedWithTinyMCE

export { updateNewsPrevNextLinksAddedWithTinyMCE }
